import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";

@Component({
  selector: 'page-xp-unit-info',
  templateUrl: 'xp-unit-info.html'
})
export class XpUnitInfoPage {

  unit:any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public superTabsCtrl: SuperTabsController
  ) {
    this.unit = navParams.get('unit');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-unit-info/xp-unit-info.ts